import {
  Box,
  Input,
  Text,
  HStack,
  VStack,
  Alert,
  AlertIcon,
  FormLabel
} from '@chakra-ui/react';
import { MdDateRange } from 'react-icons/md';

interface FiltroRangoFechasProps {
  fechaInicio: string;
  fechaFin: string;
  onFechaInicioChange: (fecha: string) => void;
  onFechaFinChange: (fecha: string) => void;
  error?: string;
}

export default function FiltroRangoFechas({
  fechaInicio,
  fechaFin,
  onFechaInicioChange,
  onFechaFinChange,
  error
}: FiltroRangoFechasProps) {
  const formatearFecha = (fechaString: string) => {
    const [año, mes, dia] = fechaString.split('-');
    return `${dia}/${mes}/${año}`;
  };
  return (
    <VStack spacing={3} align="stretch">
      <HStack spacing={3} align="end">
        <Box flex={1}>
          <FormLabel fontSize="sm" color="gray.600" mb={1}>
            Fecha Inicio
          </FormLabel>
          <Input
            type="date"
            value={fechaInicio}
            onChange={e => onFechaInicioChange(e.target.value)}
            bg="white"
            size="md"
            borderColor={error ? "red.300" : "gray.200"}
            placeholder="Desde el inicio del día"
          />
        </Box>
        
        <Box flex={1}>
          <FormLabel fontSize="sm" color="gray.600" mb={1}>
            Fecha Fin
          </FormLabel>
          <Input
            type="date"
            value={fechaFin}
            onChange={e => onFechaFinChange(e.target.value)}
            bg="white"
            size="md"
            borderColor={error ? "red.300" : "gray.200"}
            placeholder="Hasta el final del día"
          />
        </Box>
      </HStack>

      {error && (
        <Alert status="error" size="sm" borderRadius="md">
          <AlertIcon />
          <Text fontSize="sm">{error}</Text>
        </Alert>
      )}

      {(fechaInicio || fechaFin) && !error && (
        <Box bg="blue.50" p={2} borderRadius="md" border="1px solid" borderColor="blue.200">
          <HStack spacing={2}>
            <MdDateRange color="#3182ce" />
            <Text fontSize="sm" color="blue.700">
              {fechaInicio && fechaFin 
                ? `Rango completo: ${formatearFecha(fechaInicio)} - ${formatearFecha(fechaFin)}`
                : fechaInicio 
                  ? `Desde inicio del día: ${formatearFecha(fechaInicio)}`
                  : `Hasta final del día: ${formatearFecha(fechaFin)}`
              }
            </Text>
          </HStack>
        </Box>
      )}
    </VStack>
  );
}